export default __webpack_public_path__ + "static/media/96.07179173.jpg";